export default __webpack_public_path__ + "74a875f3ba3c0147ea10a72644826b51.svg";